import { FooterFormStateProvider } from "@chq/components";
import { theme, ThemeProvider } from "@chq/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { I18nextProvider } from "react-i18next";
import LuckyOrange from "./components/lucky-orange";
import i18n from "./i18n";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "./ui";

// This tag will be added to the environmental variables and assigned dynamically
// to either a development or production account based on the url
// It will also be place in a try/catch block for so that it is not installed if Google Tag Manager is down and won't affect our site
const tagManagerArgs = {
  gtmId: window.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
};

try {
  TagManager.initialize(tagManagerArgs);
} catch {}

const Loading: React.FC = () => {
  return <div>Loading...</div>;
};

const Root: React.FC = () => {
  return (
    <React.StrictMode>
      <React.Suspense fallback={<Loading />}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <FooterFormStateProvider>
              <LuckyOrange>
                <App></App>
              </LuckyOrange>
            </FooterFormStateProvider>
          </ThemeProvider>
        </I18nextProvider>
      </React.Suspense>
    </React.StrictMode>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
